import React, { Component } from 'react';
import { connect } from "react-redux";
import AddZoneForm1 from '../../_ModalsForms/Zones/AddZoneForm_1';
import AddZoneForm2 from '../../_ModalsForms/Zones/AddZoneForm_2';

class AddZoneForms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal_close: false,
        };
    }

    render(ClientSideZoneState) {
        
        let modal_form, modal_form_1, modal_form_2, State_from_Form1 = null;
        State_from_Form1 = this.props.ClientSideZoneState;

        modal_form_1 = <AddZoneForm1 onClick={this.props.nextForm} />             /* Form 1 modal Content, this form has new zone name and list of Building fields. */
        modal_form_2 = <AddZoneForm2 />                                          /* Form 2 modal Content, this form has new zone name and  list of Building fields. */

        modal_form = (State_from_Form1.FormDisplay === false) ? modal_form_2 :  modal_form_1;
        
        return (
            <div>{modal_form}</div>
        );
    }
}

const mapStateToProps = state => {
    return {
        ClientSideZoneState: state.zonesRootReducer.ClientSideZonesData,
    };
};

export default connect(mapStateToProps, null)(AddZoneForms);




